<div [ngClass]="selectedItem==true? 'circle-minus': 'circle-plus'"
    [style.left]=leftPosition
    [style.top]=topPosition
    *ngIf="makingSelectionsState==true"
    style="margin-top: -25px;"
    ></div>
